import React from "react";
import { Modal, Button } from "react-bootstrap";
import {
  ExclamationTriangleFill,
  ExclamationTriangle,
  CurrencyDollar,
} from "react-bootstrap-icons";
import { formatNumbers } from "../Utils";

const UrgentNsfModal = ({
  show,
  onHide,
  onHandleNow,
  onReviewLater,
  nsfData,
}) => {
  // Static NSF data
  const nsfDataText = {
    totalCases: 5,
    totalAmount: "11,847.5",
    nsfFees: 175,
    overdueLoans: 3,
    title: "Urgent Payment Issues",
    message: "loan(s) with failed payment(s) due to insufficient funds",
  };

  const handleHandleNow = () => {
    if (onHandleNow) onHandleNow();
    onHide();
  };

  const handleReviewLater = () => {
    if (onReviewLater) onReviewLater();
    onHide();
  };

  return (
    <>
      {/* Urgent NSF Issues Modal */}
      <Modal
        show={show}
        onHide={onHide}
        size="md"
        centered
        className="urgent-nsf-modal"
      >
        <Modal.Body className="urgent-nsf-modal-body">
          {/* Header Alert Section */}
          <div className="urgent-nsf-header">
            <div className="urgent-nsf-icon">
              <ExclamationTriangleFill size={24} />
            </div>
            <div className="urgent-nsf-content">
              <div className="urgent-nsf-title">{nsfDataText.title}</div>
              <div className="urgent-nsf-message">
                You have {nsfData.totalRecords} {nsfDataText.message}
              </div>
            </div>
          </div>

          {/* NSF Stats Section */}
          <div className="urgent-nsf-stats">
            <div className="urgent-nsf-stat-item">
              <div className="urgent-nsf-stat-icon">
                <CurrencyDollar size={20} />
              </div>
              <div className="urgent-nsf-stat-content">
                <div className="urgent-nsf-stat-label">Total NSF Amount</div>
                <div className="urgent-nsf-stat-value">
                  {formatNumbers(Math.abs(nsfData?.TotalNSFAmount))}
                </div>
              </div>
            </div>
          </div>

          {/* Overdue Warning */}
          <div className="urgent-nsf-warning">
            <div className="urgent-nsf-warning-icon">
              <ExclamationTriangle size={18} />
            </div>
            <div className="urgent-nsf-warning-text">
              {nsfData.totalRecords}{" "}
              {nsfData.totalRecords > 1 ? "Payments are" : "Payment is"} overdue
              and may incur additional penalties.
            </div>
          </div>

          {/* Action Items */}
          <div className="urgent-nsf-actions">
            <div className="urgent-nsf-actions-title">
              Take immediate action to:
            </div>
            <ul className="urgent-nsf-actions-list">
              <li>Update your payment method, if needed</li>
              <li>Retry NSF payments</li>
              <li>Potentially Avoid additional late fees</li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="urgent-nsf-buttons">
            <button
              onClick={handleReviewLater}
              className="urgent-nsf-later-btn"
            >
              Remind Me Later
            </button>
            <button onClick={handleHandleNow} className="urgent-nsf-handle-btn">
              Resolve Payment Issues
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <style jsx>{`
        /* Urgent NSF Modal Styles */
        .urgent-nsf-modal .modal-content {
          border-radius: 12px !important;
          border: none !important;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
          overflow: hidden !important;
        }

        .urgent-nsf-modal-body {
          padding: 0 !important;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif !important;
          background: white !important;
        }

        /* Header Alert Section */
        .urgent-nsf-header {
          padding: 24px 24px 20px 24px !important;
          display: flex !important;
          align-items: center !important;
          border-bottom: none !important;
        }

        .urgent-nsf-icon {
          margin-right: 16px !important;
          color: #dc3545 !important;
          display: flex !important;
          align-items: center !important;
        }

        .urgent-nsf-content {
          flex: 1 !important;
        }

        .urgent-nsf-title {
          font-size: 20px !important;
          font-weight: 600 !important;
          color: #dc3545 !important;
          margin-bottom: 4px !important;
          line-height: 1.3 !important;
        }

        .urgent-nsf-message {
          font-size: 16px !important;
          color: #dc3545 !important;
          opacity: 0.9 !important;
          margin: 0 !important;
        }

        /* NSF Stats Section */
        .urgent-nsf-stats {
          padding: 20px 24px;
          display: flex;
          padding: 10px;
          margin: 20px;
          background: #f8d7da;
          border-radius: 8px;
          border: 1px solid #f5c6cb;
        }

        .urgent-nsf-stat-item {
          flex: 1;
          border-radius: 8px;
          padding: 18px;
          display: flex;
          align-items: center;
        }

        .urgent-nsf-stat-icon {
          margin-right: 14px;
          display: flex;
          align-items: center;
        }

        .urgent-nsf-stat-item:first-child .urgent-nsf-stat-icon {
          color: #856404;
        }

        .urgent-nsf-stat-item:last-child .urgent-nsf-stat-icon {
          color: #721c24;
        }

        .urgent-nsf-stat-content {
          flex: 1;
        }

        .urgent-nsf-stat-label {
          font-size: 14px;
          color: #6c757d;
          margin-bottom: 4px;
          font-weight: 500;
        }

        .urgent-nsf-stat-value {
          font-size: 24px;
          font-weight: 700;
          color: #2c3e50;
        }

        /* Overdue Warning */
        .urgent-nsf-warning {
          background: #f8d7da;
          margin: 0 24px 20px 24px;
          padding: 16px;
          border-radius: 8px;
          border: 1px solid #f5c6cb;
          display: flex;
          align-items: flex-start;
        }

        .urgent-nsf-warning-icon {
          margin-right: 12px;
          color: #dc3545;
          margin-top: 2px;
        }

        .urgent-nsf-warning-text {
          font-size: 15px;
          color: #721c24;
          line-height: 1.5;
          margin: 0;
        }

        /* Action Items */
        .urgent-nsf-actions {
          margin: 0 24px 20px 24px;
        }

        .urgent-nsf-actions-title {
          font-size: 16px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 12px;
        }

        .urgent-nsf-actions-list {
          margin: 0;
          padding-left: 20px;
          color: #495057;
        }

        .urgent-nsf-actions-list li {
          margin-bottom: 8px;
          line-height: 1.5;
          font-size: 15px;
        }

        .urgent-nsf-actions-list li:last-child {
          margin-bottom: 0;
        }

        /* Action Buttons */
        .urgent-nsf-buttons {
          display: flex;
          justify-content: center;
          gap: 16px;
          padding: 10px;
          margin: 20px;
          /* border-top: 1px solid #dee2e6; */
          /* background: #f8f9fa; */
        }

        .urgent-nsf-later-btn {
          background: white;
          color: #6c757d;
          border: 2px solid #dee2e6;
          border-radius: 8px;
          padding: 12px 48px;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s ease;
          min-width: 140px;
        }

        .urgent-nsf-later-btn:hover {
          background: #f8f9fa;
          color: #495057;
          border-color: #adb5bd;
          transform: translateY(-1px);
        }

        .urgent-nsf-handle-btn {
          background: #dc3545;
          color: white;
          border: 2px solid #dc3545;
          border-radius: 8px;
          padding: 12px 48px;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.2s ease;
          min-width: 140px;
        }

        .urgent-nsf-handle-btn:hover {
          background: #c82333;
          border-color: #c82333;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
        }

        /* Responsive Design for Urgent NSF Modal */
        @media (max-width: 768px) {
          .urgent-nsf-header {
            padding: 20px;
          }

          .urgent-nsf-title {
            font-size: 18px;
          }

          .urgent-nsf-message {
            font-size: 14px;
          }

          .urgent-nsf-stats {
            flex-direction: column;
            padding: 20px;
            gap: 16px;
          }

          .urgent-nsf-stat-value {
            font-size: 20px;
          }

          .urgent-nsf-warning,
          .urgent-nsf-actions {
            margin: 0 20px 16px 20px;
          }

          .urgent-nsf-buttons {
            flex-direction: column;
            gap: 12px;
            padding: 20px;
          }
        }
      `}</style>
    </>
  );
};

export default UrgentNsfModal;
